import React, {useContext, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'

import {BASE_CLASS, NOTIFICATIONS} from './config.js'
import {Notification} from './notification.js'

const NotificationsAdFavorite = ({isAddSuccessHidden = false, showNotification = NOTIFICATIONS.EMPTY, className}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {CREATED: HTTP_STATUS_CODE_CREATED} = config.get('COMMON').HTTP_STATUS_CODES
  const {USER_NOT_LOGGED_IN_USER_ERROR} = config.get('ERRORS')
  const [notification, setNotification] = useState(showNotification)

  useMount(() => {
    const onAddSuccess = ({params, result}) => {
      result.status === HTTP_STATUS_CODE_CREATED && setNotification(NOTIFICATIONS.SUCCESS)
    }
    const onAddError = ({params, error}) => {
      if (!(error instanceof USER_NOT_LOGGED_IN_USER_ERROR)) setNotification(NOTIFICATIONS.ERROR)
    }
    const onDeleteSuccess = () => setNotification(NOTIFICATIONS.SUCCESS_DELETE)
    const onDeleteError = () => setNotification(NOTIFICATIONS.ERROR_DELETE)

    const _addUserFavorite$ = domain.get('add_user_favorites_use_case').$.execute.subscribe(onAddSuccess, onAddError)
    const _deleteUserFavorite$ = domain
      .get('delete_user_favorites_use_case')
      .$.execute.subscribe(onDeleteSuccess, onDeleteError)

    return () => {
      _addUserFavorite$?.dispose?.()
      _deleteUserFavorite$?.dispose?.()
    }
  })

  const _handleOnCloseNotification = () => {
    setNotification(NOTIFICATIONS.EMPTY)
  }

  const isNotificationHidden = isAddSuccessHidden && notification === NOTIFICATIONS.SUCCESS

  return (
    <>
      {notification !== NOTIFICATIONS.EMPTY && !isNotificationHidden && (
        <div className={cx(BASE_CLASS, className)}>
          <Notification onClose={_handleOnCloseNotification} type={notification} />
        </div>
      )}
    </>
  )
}

NotificationsAdFavorite.displayName = 'NotificationsAdFavorite'

NotificationsAdFavorite.propTypes = {
  className: PropTypes.string,
  /**
   * Suppresses ONLY the add-to-favorites success notification. Deletion and error
   * notifications keep rendering. Used when another surface already confirms the add
   */
  isAddSuccessHidden: PropTypes.bool,
  showNotification: PropTypes.oneOf([
    NOTIFICATIONS.EMPTY,
    NOTIFICATIONS.ERROR,
    NOTIFICATIONS.SUCCESS,
    NOTIFICATIONS.SUCCESS_DELETE,
    NOTIFICATIONS.ERROR_DELETE
  ])
}

export default NotificationsAdFavorite

export {NOTIFICATIONS}
